<!-- 组件说明 -->
<template>
  <div class="app-container">
    <div class="content">
      <div class="info-title">404</div>
      <div class="info-sub-title">Did not find</div>
      <div class="info-description">
        Sorry, we cannot find what you are looking for.
      </div>
    </div>
    <div class="footer">© 2024 Citcon All rights reserved.</div>
  </div>
</template>
  
  <script>
</script>
  
<style lang="scss" scoped>
.app-container {
  width: 100%;
  height: 100%;
  background-color: #e3e8ef;
  font: 14px / 1.6 "helvetica neue", helvetica, arial, "lucida grande",
    "Microsoft YaHei", sans-serif, Arial, sans-serif;
  .content {
    padding-top: 12%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #4f5866;

    .info-title {
      height: 192px;
      font-size: 120px;
      font-weight: bold;
    }
    .info-sub-title {
      height: 64px;
      font-size: 40px;
      font-weight: bold;
    }
    .info-description {
      height: 22.39px;
      margin-top: 30px;
      font-size: 14px;
    }
  }

  .footer {
    height: 22.39px;
    color: #4f5866;
    position: fixed;
    bottom: 40px;
    width: 100%;
    font-size: 14px;
    text-align: center;
  }
}
</style>
  